export interface IAssociateRegionToCustomerResponse {
  igsCustomerNumber: string;
  success: boolean;
  errors: string[];
}

export class AssociateRegionToCustomerResponse
  implements IAssociateRegionToCustomerResponse {
  igsCustomerNumber: string;
  success: boolean;
  errors: string[];
}
